@if ((loader.state$ | async)?.loading) {
<div class="fixed inset-0 z-[2147483646]
         flex items-center justify-center
         bg-slate-900/50
         backdrop-blur-[2px]
         transition-opacity duration-300">

  <div class="flex flex-col items-center gap-8 animate-scaleIn">

    <!-- SHARP FLOATING SPINNER -->
    <div class="relative w-16 h-16 flex items-center justify-center">

      <!-- Track Ring (Blue/App Color context) -->
      <div class="absolute inset-0 border-[3px] border-indigo-500/30 rounded-full"></div>

      <!-- Active Spin Ring (Moving White) -->
      <div class="absolute inset-0 border-[3px] border-white border-t-transparent rounded-full animate-spin"></div>

      <!-- Inner Pulsing Dot (Blue/App Color) -->
      <div class="w-3 h-3 bg-indigo-500 rounded-full animate-pulse shadow-lg ring-2 ring-indigo-500/30"></div>

    </div>

    <!-- TEXT -->
    @if ((loader.state$ | async)?.showText) {
    <div class="flex flex-col items-center gap-1">
      <p class="text-white font-medium text-sm tracking-[0.2em] uppercase opacity-90">
        {{ ((loader.state$ | async)?.text || '') | translate }}
      </p>
      <!-- Loading dots? Optional -->
    </div>
    }

  </div>
</div>
}